import React from 'react';
import { motion } from 'framer-motion';
import { CalendarHeartIcon } from 'lucide-react';
export function Results() {
  return <section className="py-12 md:py-16 bg-amber-500" data-id="element-177">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-178">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="bg-white rounded-3xl p-6 md:p-12 shadow-xl" data-id="element-179">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-amber-100 text-amber-600 mb-4 md:mb-6" data-id="element-180">
            <CalendarHeartIcon size={32} data-id="element-181" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-charcoal mb-4 md:mb-6" data-id="element-182">
            La diferencia en 7 días
          </h2>
          <p className="text-xl md:text-2xl text-charcoal-light leading-relaxed" data-id="element-183">
            En una semana, notarás que tu perro ya no se levanta del sillón
            apenas agarrás las llaves.{' '}
            <strong className="text-charcoal font-semibold" data-id="element-184">
              Ese primer silencio es el indicador de que su cerebro ha empezado
              a sanar.
            </strong>
          </p>
        </motion.div>
      </div>
    </section>;
}